import CreateSwapOrder from "./CreateUserSwapOrder";
import GetSwapPrice from "./GetUserSwapPrice";
import GetSwapRecord from "./GetUserSwapRecord";
import GetSwapRecoredList from "./GetUserSwapRecoredList";

export default function Index() {
  return (
    <>
      <GetSwapPrice />
      <CreateSwapOrder />
      <GetSwapRecord />
      <GetSwapRecoredList />
    </>
  );
}
